module.exports = __webpack_public_path__ + "media/images/athletes/2504-aa98e7a66cec58e72c9417c35937ffe0.png";